import { render } from "./GTComponent.vue?vue&type=template&id=539b5b24&scoped=true"
import script from "./GTComponent.vue?vue&type=script&lang=js"
export * from "./GTComponent.vue?vue&type=script&lang=js"

import "./GTComponent.vue?vue&type=style&index=0&id=539b5b24&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-539b5b24"

export default script